import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import React, { Component } from 'react';
import RcUpload from './Upload';
import UploadList from './uploadList';
import getFileItem from './getFileItem';
import classNames from 'classnames';
import assign from 'object-assign';
import PropTypes from 'prop-types';
import Modal from '../../wui-modal/src';
import { prefix } from "../../wui-core/src/index.js"; //import { UploadProps } from './interface';

function T() {
  return true;
} // Fix IE file.status problem
// via coping a new Object


function fileToObject(file) {
  return {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.filename || file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    response: file.response,
    error: file.error,
    percent: 0,
    originFileObj: file,
    status: null
  };
}
/**
 * 生成Progress percent: 0.1 -> 0.98
 *   - for ie
 */


function genPercentAdd() {
  var k = 0.1;
  var i = 0.01;
  var end = 0.98;
  return function (s) {
    var start = s;

    if (start >= end) {
      return start;
    }

    start += k;
    k = k - i;

    if (k < 0.001) {
      k = 0.001;
    }

    return start * 100;
  };
}

function Dragger(props) {
  return /*#__PURE__*/React.createElement(Upload, _extends({}, props, {
    type: "drag",
    style: {
      height: props.height
    }
  }));
}

function getBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      return resolve(reader.result);
    };

    reader.onerror = function (error) {
      return reject(error);
    };
  });
}

var File = {
  uid: PropTypes.number,
  size: PropTypes.number,
  name: PropTypes.string,
  lastModifiedDate: PropTypes.date,
  url: PropTypes.string,
  status: PropTypes.oneOf(['error', 'success', 'done', 'uploading', 'removed']),
  percent: PropTypes.number,
  thumbUrl: PropTypes.string // originFileObj: File

};
var UploadChangeParam = {
  file: File,
  fileList: PropTypes.array,
  event: PropTypes.object
};
var propTypes = {
  type: PropTypes.oneOf(['drag', 'select']),
  name: PropTypes.string,
  defaultFileList: PropTypes.array,
  fileList: PropTypes.array,
  action: PropTypes.string,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  headers: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  showUploadList: PropTypes.bool,
  multiple: PropTypes.bool,
  accept: PropTypes.string,
  beforeUpload: PropTypes.func,
  onChange: PropTypes.func,
  listType: PropTypes.oneOf(['text', 'picture', 'picture-card']),
  className: PropTypes.string,
  onPreview: PropTypes.func,
  onRemove: PropTypes.func,
  preventDefaultPreview: PropTypes.bool,
  supportServerRender: PropTypes.bool,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  clsPrefix: PropTypes.string,
  enterDragger: PropTypes.func,
  leaveDragger: PropTypes.func,
  mergeFiles: PropTypes.bool,
  removeText: PropTypes.string,
  downloadText: PropTypes.string,
  onDownload: PropTypes.func,
  locale: PropTypes.object
};
var defaultProps = {
  clsPrefix: "".concat(prefix, "-upload"),
  type: 'select',
  multiple: false,
  // 是否支持多文件上传 兼容ie10以上
  action: '',
  // 上传的服务器地址
  data: {},
  // 上传所需参数或返回上传参数的方法
  accept: '',
  // 接受上传的文件类型
  beforeUpload: T,
  // 上传文件之前的钩子
  showUploadList: true,
  // 是否展示文件列表, 可设为一个对象，用于单独设定 `showPreviewIcon`、 `showDownloadIcon` 和 `showRemoveIcon`
  listType: 'text',
  // or pictrue 上传列表的内建样式，支持三种基本样式 text, picture 和 picture-card
  className: '',
  disabled: false,
  // 是否禁用，设置为 true 后前端禁止删除已上传文件
  supportServerRender: true,
  // 服务端渲染时需要打开这个
  preventDefaultPreview: false,
  enterDragger: function enterDragger() {},
  // 拖拽上传，当鼠标拖拽文件进入 Dragger 区域时触发
  leaveDragger: function leaveDragger() {},
  // 拖拽上传，当鼠标拖拽文件离开 Dragger 区域时触发
  defaultFileList: [],
  // 默认已经上传的文件列表
  // fileList: [], // 已上传的文件列表,多用于onChange事件里
  headers: {},
  // 设置上传的请求头部，IE10 以上有效
  name: 'file',
  // 发到后台的文件参数名
  onChange: function onChange() {},
  // 当上传状态改变之后执行的回调函数
  onRemove: function onRemove() {},
  // 点击移除文件时的回调，返回值为 false 时不移除。支持返回一个 Promise 对象，Promise 对象 resolve(false) 或 reject 时不移除
  mergeFiles: false,
  // 是否合并上传文件数组
  removeText: '',
  // 移除文件的文本
  downloadText: '',
  // 下载文件的文本
  onPreview: function onPreview() {},
  // 点击文件链接或预览图标时的回调
  onDownload: null,
  locale: {}
};

var Upload = /*#__PURE__*/function (_Component) {
  _inherits(Upload, _Component);

  var _super = _createSuper(Upload);

  // recentUploadStatus: boolean | PromiseLike<any>;
  // progressTimer: any;
  // refs: {
  //   [key: string]: any;
  //   upload: any;
  // };
  function Upload(props) {
    var _this;

    _classCallCheck(this, Upload);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      previewVisible: false,
      previewImage: ''
    });

    _defineProperty(_assertThisInitialized(_this), "onStart", function (file) {
      var targetItem;

      var nextFileList = _this.state.fileList.concat();

      if (file.length > 0) {
        targetItem = file.map(function (f) {
          var fileObject = fileToObject(f);
          fileObject.status = 'uploading';
          return fileObject;
        });
        nextFileList = nextFileList.concat(targetItem);
      } else {
        targetItem = fileToObject(file);
        targetItem.status = 'uploading';
        nextFileList.push(targetItem);
      }

      _this.onChange({
        file: targetItem,
        fileList: nextFileList
      }); // fix ie progress
      //if (!(window as any).FormData) {


      if (!window.FormData) {
        _this.autoUpdateProgress(0, targetItem);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSuccess", function (response, file) {
      _this.clearProgressTimer();

      try {
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }
      } catch (e) {
        /* do nothing */
      }

      var fileList = _this.state.fileList;
      var targetItem = getFileItem(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.status = 'done';
      targetItem.response = response;

      _this.onChange({
        file: targetItem,
        fileList: fileList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onProgress", function (e, file) {
      var fileList = _this.state.fileList;
      var targetItem = getFileItem(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.percent = e.percent;

      _this.onChange({
        event: e,
        file: targetItem,
        fileList: _this.state.fileList
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function (error, response, file) {
      _this.clearProgressTimer();

      var fileList = _this.state.fileList;
      var targetItem = getFileItem(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.error = error;
      targetItem.response = response;
      targetItem.status = 'error';

      _this.handleRemove(targetItem);
    });

    _defineProperty(_assertThisInitialized(_this), "handleManualRemove", function (file) {
      _this.upload.abort(file);

      file.status = 'removed'; // eslint-disable-line

      _this.handleRemove(file);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (info) {
      if (!('fileList' in _this.props)) {
        _this.setState({
          fileList: info.fileList
        });
      }

      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(info);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", function (e) {
      _this.lastenter = e.target; // 记录最后进入的元素

      _this.setState({
        dragState: 'dragover'
      });

      _this.props.enterDragger();
    });

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function (e) {
      // 如果此时退的元素是最后进入的元素，说明是真正退出了`drag-zone`元素
      if (_this.lastenter === e.target) {
        _this.setState({
          dragState: e.type
        });

        e.stopPropagation();
        e.preventDefault();

        _this.props.leaveDragger();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFileDrop", function (e) {
      _this.setState({
        dragState: e.type
      });

      _this.props.leaveDragger();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePreview", function (file) {
      var _this$props = _this.props,
          onPreview = _this$props.onPreview,
          preventDefaultPreview = _this$props.preventDefaultPreview;

      var displayPreview = function displayPreview() {
        _this.setState({
          previewImage: file.url || file.thumbUrl,
          previewVisible: true
        });
      };

      if (preventDefaultPreview === false) {
        if (!file.url && !file.thumbUrl) {
          getBase64(file.originFileObj).then(displayPreview);
        } else {
          displayPreview();
        }
      }

      if (onPreview && Object.prototype.toString.call(onPreview) === "[object Function]") {
        onPreview(file);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDownload", function (file) {
      var onDownload = _this.props.onDownload;

      if (typeof onDownload === 'function') {
        onDownload(file);
      } else if (file.url) {
        window.open(file.url);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      return _this.setState({
        previewVisible: false
      });
    });

    _this.state = {
      fileList: _this.props.fileList || _this.props.defaultFileList || [],
      dragState: 'drop'
    };
    _this.lastenter = null;
    return _this;
  }

  _createClass(Upload, [{
    key: "autoUpdateProgress",
    value: function autoUpdateProgress(_, file) {
      var _this2 = this;

      var getPercent = genPercentAdd();
      var curPercent = 0;
      this.progressTimer = setInterval(function () {
        curPercent = getPercent(curPercent);

        _this2.onProgress({
          percent: curPercent
        }, file);
      }, 200);
    }
  }, {
    key: "removeFile",
    value: function removeFile(file) {
      var fileList = this.state.fileList;
      var targetItem = getFileItem(file, fileList);
      var index = fileList.indexOf(targetItem);

      if (index !== -1) {
        fileList.splice(index, 1);
        return fileList;
      }

      return null;
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(file) {
      var _this3 = this;

      var onRemove = this.props.onRemove;
      var fileList = this.state.fileList;
      var status = file.status;
      file.status = 'removed'; // eslint-disable-line

      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
        // Prevent removing file
        if (ret === false) {
          file.status = status;
          return;
        }

        var removedFileList = _this3.removeFileItem(file, fileList);

        if (removedFileList) {
          _this3.onChange({
            file: file,
            fileList: removedFileList
          });
        }
      });
    }
  }, {
    key: "removeFileItem",
    value: function removeFileItem(file, fileList) {
      var matchKey = file.uid !== undefined ? 'uid' : 'name';
      var removed = fileList.filter(function (item) {
        return item[matchKey] !== file[matchKey];
      });

      if (removed.length === fileList.length) {
        return null;
      }

      return removed;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('fileList' in nextProps) {
        this.setState({
          fileList: nextProps.fileList || []
        });
      }
    }
  }, {
    key: "clearProgressTimer",
    value: function clearProgressTimer() {
      clearInterval(this.progressTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this,
          _classNames2;

      var _this$props2 = this.props,
          _this$props2$clsPrefi = _this$props2.clsPrefix,
          clsPrefix = _this$props2$clsPrefi === void 0 ? '' : _this$props2$clsPrefi,
          showUploadList = _this$props2.showUploadList,
          listType = _this$props2.listType,
          type = _this$props2.type,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          className = _this$props2.className,
          removeText = _this$props2.removeText,
          downloadText = _this$props2.downloadText,
          locale = _this$props2.locale;
      var showRemoveIcon = showUploadList.showRemoveIcon,
          showDownloadIcon = showUploadList.showDownloadIcon,
          showPreviewIcon = showUploadList.showPreviewIcon;
      var _this$state = this.state,
          previewVisible = _this$state.previewVisible,
          previewImage = _this$state.previewImage;
      var rcUploadProps = assign({}, this.props, {
        onStart: this.onStart,
        onError: this.onError,
        onProgress: this.onProgress,
        onSuccess: this.onSuccess // beforeUpload:this.beforeUpload

      });
      delete rcUploadProps.className;
      var uploadList = showUploadList ? /*#__PURE__*/React.createElement(UploadList, {
        listType: listType,
        items: this.state.fileList,
        onPreview: this.handlePreview,
        onRemove: this.handleManualRemove,
        removeText: removeText || '',
        downloadText: downloadText || '',
        showRemoveIcon: !disabled && showRemoveIcon,
        showDownloadIcon: !disabled && showDownloadIcon,
        onDownload: this.onDownload,
        showPreviewIcon: showPreviewIcon,
        locale: locale
      }) : null;

      if (type === 'drag') {
        var _classNames;

        var dragCls = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "-drag"), true), _defineProperty(_classNames, "".concat(clsPrefix, "-drag-uploading"), this.state.fileList.some(function (file) {
          return file.status === 'uploading';
        })), _defineProperty(_classNames, "".concat(clsPrefix, "-drag-hover"), this.state.dragState === 'dragover'), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _classNames));
        return /*#__PURE__*/React.createElement("span", {
          className: className
        }, /*#__PURE__*/React.createElement("div", {
          className: dragCls,
          onDrop: this.onFileDrop // onDragOver={this.onFileDrop}
          ,
          onDragLeave: this.onDragLeave,
          onDragEnter: this.onDragEnter
        }, /*#__PURE__*/React.createElement(RcUpload, _extends({}, rcUploadProps, {
          ref: function ref(el) {
            return _this4.upload = el;
          },
          className: "".concat(clsPrefix, "-btn")
        }), /*#__PURE__*/React.createElement("div", {
          className: "".concat(clsPrefix, "-drag-container")
        }, children))), uploadList);
      }

      var uploadButtonCls = classNames(clsPrefix, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(clsPrefix, "-select"), true), _defineProperty(_classNames2, "".concat(clsPrefix, "-select-").concat(listType), true), _defineProperty(_classNames2, "".concat(clsPrefix, "-disabled"), disabled), _classNames2));
      var uploadButton = /*#__PURE__*/React.createElement("div", {
        className: uploadButtonCls,
        style: {
          display: children ? '' : 'none'
        }
      }, /*#__PURE__*/React.createElement(RcUpload, _extends({}, rcUploadProps, {
        ref: function ref(el) {
          return _this4.upload = el;
        }
      })));

      if (listType === 'picture-card') {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
          className: className
        }, uploadList, uploadButton), /*#__PURE__*/React.createElement(Modal, {
          show: previewVisible,
          onHide: this.handleCancel,
          onOk: this.handleCancel
        }, /*#__PURE__*/React.createElement(Modal.Header, {
          closeButton: true
        }, /*#__PURE__*/React.createElement(Modal.Title, null, "\u5927\u56FE\u9884\u89C8")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("img", {
          alt: "example",
          style: {
            width: '100%'
          },
          src: previewImage
        }))));
      }

      return /*#__PURE__*/React.createElement("span", {
        className: className
      }, uploadButton, uploadList);
    }
  }]);

  return Upload;
}(Component);

Upload.propTypes = propTypes;
Upload.defaultProps = defaultProps;
Upload.Dragger = Dragger;
export default Upload;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-upload/src/index.js